// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
import { useEffect, useState } from "react";

// Material Dashboard 2 React components
import MDBox from "../../components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "../../widgets/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../widgets/Navbars/DashboardNavbar";
import Footer from "../../widgets/Footer";
import DataTable from "../../widgets/Tables/DataTable";
import ToastWidget from "widgets/Toast";
import {
  getContracts,
  deleteContract,
  getContract,
  setPayment,
} from "../../domain/apis/contractService";
import ContractModifyComponent from "./contractModifyComponent";
import ContractDetailComponent from "./contractDetailComponent";

// Data
import renderTableData from "./data/tableData";

function Contracts() {
  const [dataset, setDataset] = useState({
    columns: [],
    rows: [],
  });

  const [uiToast, setUIToast] = useState({
    isShow: false,
    message: "",
  });

  const [reload, setReload] = useState(0);
  const [modifyDialogShow, setModifyDialogShow] = useState({
    show: false,
    data: null,
    key: `dialog${new Date()}`,
  });
  const [detailDialogShow, setDetailDialogShow] = useState({
    show: false,
    data: null,
    key: `dialog${new Date()}`,
  });

  const reloadPage = () => {
    setReload(reload + 1);
  };

  useEffect(() => {
    // reset
    setDataset({
      columns: [],
      rows: [],
    });

    getContracts().subscribe({
      next({ data }) {
        const { results } = data;
        setDataset(
          renderTableData({
            model: results,
            deleteEvent,
            detailEvent,
            paymentEvent: (id) => {
              const choice = window.confirm("Xác nhận đã thanh toán!");
              if (choice) {
                handlePayment(id);
              }
            },
          })
        );
      },
      error(err) {
        setUIToast({
          isShow: true,
          message: err.message,
        });
      },
    });
  }, [reload]);

  function handleDelete(id) {
    deleteContract(id).subscribe({
      next({ data }) {
        if (data.status) {
          setUIToast({
            isShow: true,
            message: "Đã xoá!!!",
          });

          setTimeout(() => {
            reloadPage();
          }, 2000);
        }
      },
      error(err) {
        setUIToast({
          isShow: true,
          message: err.message,
        });
      },
    });
  }

  function handlePayment(id) {
    setPayment({ id }).subscribe({
      next({ data }) {
        if (data.status) {
          setUIToast({
            isShow: true,
            message: "Đã chuyển trạng thái!!!",
          });

          setTimeout(() => {
            reloadPage();
          }, 2000);
        }
      },
      error(err) {
        setUIToast({
          isShow: true,
          message: err.message,
        });
      },
    });
  }

  function handleShowDetail(id) {
    getContract(id).subscribe({
      next({ data }) {
        setDetailDialogShow({
          show: true,
          ...data,
          key: `dialog${new Date()}`,
        });
      },
      error(err) {
        setUIToast({
          isShow: true,
          message: err.message,
        });
      },
    });
  }

  // events
  function deleteEvent(id) {
    const choice = window.confirm("Bạn có muốn xoá?");
    if (choice) {
      handleDelete(id);
    }
  }

  function detailEvent(id) {
    handleShowDetail(id);
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ToastWidget
        key="toast"
        isShow={uiToast.isShow}
        message={uiToast.message}
        onClose={() => setUIToast({ isShow: false })}
      />
      <ContractModifyComponent
        data={modifyDialogShow.data}
        show={modifyDialogShow.show}
        key={modifyDialogShow.key}
        handleClose={(data) => {
          setModifyDialogShow({
            show: false,
            key: `dialog${new Date()}`,
          });
          if (data?.isReload) {
            reloadPage();
          }
        }}
      />
      <ContractDetailComponent
        data={detailDialogShow.data}
        show={detailDialogShow.show}
        key={detailDialogShow.key}
        handleClose={(data) => {
          setDetailDialogShow({
            show: false,
            key: `dialog${new Date()}`,
          });
          if (data?.isReload) {
            reloadPage();
          }
        }}
      />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox pt={3}>
                <div style={{ textAlign: "end", paddingRight: 24 }}>
                  <Button
                    onClick={() => {
                      setModifyDialogShow({
                        show: true,
                        data: undefined,
                      });
                    }}
                    variant="contained"
                    style={{
                      color: "white",
                    }}
                  >
                    Tạo mới
                  </Button>
                </div>
                <DataTable
                  table={dataset}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Contracts;
